import React, { useEffect, useState } from 'react';
import api from '../../utils/axios.config';
import { baseUrl } from '../../utils/url';
import { BsTrashFill } from 'react-icons/bs';
import { GrEdit } from 'react-icons/gr';

function ProvideHelp() {
  const [helps, setHelps] = useState([]);

  const handleGetHelps = async () => {
    const { data } = await api.get('provide-help');

    setHelps(data.help);
  };

  useEffect(() => {
    handleGetHelps();
  }, []);
  return (
    <div>
      <div className="flex justify-around border-b-2">
        <p>Image</p>
        <p>Title</p>
        <p>Action</p>
      </div>
      {helps?.map((help) => (
        <div
          key={help._id}
          className="flex justify-around items-center border-b-2"
        >
          <div class="avatar">
            <div class="w-24 rounded-full">
              <img src={`${baseUrl}${help.imageUrl}`} />
            </div>
          </div>
          <div>
            <p>{help.title}</p>
          </div>
          <div className="flex">
            <BsTrashFill className="mx-2" size={30} color="red" />
            <GrEdit className="mx-2" size={30} color="blue" />
          </div>
        </div>
      ))}
    </div>
  );
}

export default ProvideHelp;
